import { useSite } from 'src/context/providers/SiteProvider';
import { RoleActionTypes } from 'src/context/reducers/actionTypes';

const useRoles = () => {
  const { state, dispatch } = useSite();

  const setSelectedRole = (role: MedScout.Role | null) => {
    dispatch({ type: RoleActionTypes.SET_SELECTED_ROLE, payload: role });
  };

  const setEditOrCopyRole = (role: MedScout.Role | null) => {
    dispatch({ type: RoleActionTypes.SET_EDIT_OR_COPY_ROLE, payload: role });
  };

  return {
    ...state.roles,
    setSelectedRole,
    setEditOrCopyRole,
  };
};

export default useRoles;
